import React from 'react';
import './Message.css';
import { convertUrlsToLinks } from '../utils/urlUtils';

const Message = ({ type, content }) => {
  return (
    <div className={`message ${type}-message`}>
      {convertUrlsToLinks(content)}
    </div>
  );
};

export default Message;
